// extracted by mini-css-extract-plugin
export default {"container":"TLRHF7","button":"pwEraz","icon":"gZtya7","tooltipInner":"uALmjk","tooltipText":"Rnj0Et","tooltip":"pk2NY4"};